/** Rol de usuario (RBAC). Matchea enum Prisma Role. */
export type Role = 'OWNER' | 'ADMIN' | 'AGENT' | 'VIEWER' | 'TECNICO';

export interface User {
  id: string;
  email: string;
  name?: string | null;
  /**
   * Telefono para los avisos de "Pendientes del Vendedor" (PD-004). Nullable a
   * proposito: no todo usuario del panel es un vendedor alcanzable, y la
   * cascada cae a Employee.telefono cuando este falta.
   */
  telefono?: string | null;
  role: Role;
  isActive: boolean;
  lastLoginAt?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface Invitation {
  id: string;
  email: string;
  role: Role;
  token: string;
  expiresAt: string;
  acceptedAt?: string | null;
  createdAt: string;
}

export interface AuthTokens {
  accessToken: string;
  refreshToken: string;
}

export interface AuthResponse extends AuthTokens {
  user: User;
}

/**
 * Jerarquía de roles para enforcement en cliente/servidor.
 * OWNER > ADMIN > AGENT > VIEWER.
 * OWNER (dueño del sistema, Silva Notion) reserva las superficies sensibles:
 * API keys, consumo en USD/tokens, límites de gasto, audit log, telemetría.
 * El ADMIN (cliente) conserva TODO lo operativo. La regla es de API (403),
 * nunca solo de UI: los datos reservados no viajan al navegador de un ADMIN.
 * TECNICO queda FUERA de la jerarquía de lectura (rank 0): un técnico inicia
 * sesión pero no pasa ningún `requireRole` por jerarquía; su acceso se concede
 * por scoping explícito (su vista de trabajos, capa de operaciones).
 */
export const ROLE_RANK: Record<Role, number> = {
  OWNER: 4,
  ADMIN: 3,
  AGENT: 2,
  VIEWER: 1,
  TECNICO: 0,
};

export function hasRole(role: Role, min: Role): boolean {
  return ROLE_RANK[role] >= ROLE_RANK[min];
}
